require('@/search/index');